import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import MusicController from './MusicController.jsx'
import Social from './Social'
import {
	getBackgroundMusicUrlAndStartStatus,
	getSocialShareDataAsync,
	getStoreId,
	exhibitStoreId,
} from '../../utils/StoreConfigManager.js'
import SharePanel from './share-panel/SharePanel.jsx'
import Screenshot from './share-panel/Screenshot.jsx'
import SocialButton from './buttons/SocialButton.jsx'
import SignUpButton from './buttons/SignUpButton.jsx'
import './BottomBarLeft.css'
import UserPanel from './user-panel/UserPanel.jsx'
import BottomStoreSelector from './store-selector/BottomStoreSelector'
import IframeModal from './modals/iframe/IframeModal.jsx'
import MusicPlayer from './music-player/MusicPlayer.jsx'
import { storeId } from '../../../../variables/DevVariables.js'
import { popupStoreId } from '../../utils/StoreConfigManager.js'
const shareIconUrl = 'https://cdn.obsess-vr.com/instagram-transparent-icon.png'
const userIconUrl = 'https://cdn.obsess-vr.com/user-counter-icon.png'
const modalContent = {
	title: 'SIGN UP',
	src: 'https://slipknotmerch.com/pages/email-capture',
}

const BottomBarLeft = ({
	showSocial,
	userPanel,
	toggleUserPanel,
	userCount,
	hideUserPanel,
	isMobile,
	sceneId,
}) => {
	const [showMusicController, setShowMusicController] = useState(false)
	const [showScreenshot, setShowScreenshot] = useState(false)
	const [showSharePanel, setShowSharePanel] = useState(false)
	const [sharePanelData, setSharePanelData] = useState({})
	const [showIframe, setShowIframe] = useState(false)
	const [showMediaPlayer, setShowMediaPlayer] = useState(false)
	const [showMediaTitle, setShowMediaTitle] = useState(false)
	const [mediaVolume, setMediaVolume] = useState(1.5)

	const fetchMusicData = async () => {
		const urlAndStatus = await getBackgroundMusicUrlAndStartStatus()
		const url = urlAndStatus.url
		if (url) {
			setShowMusicController(true)
		}
	}

	const fetchSharePanelData = async () => {
		const sharePanelData = await getSocialShareDataAsync()
		setSharePanelData(sharePanelData)
	}

	const fetchStoreId = async () => {
		setShowMediaPlayer(true)
	}

	useEffect(() => {
		fetchMusicData()
		fetchSharePanelData()
		fetchStoreId()
	}, [])

	const parseNumber = (number) => {
		if (number > 999) {
			const thousands = number / Math.pow(10, 3) + 'k'
			return thousands
		}
		return number + ''
	}

	const count = parseNumber(userCount)

	const toggleSharePanel = () => {
		setShowSharePanel(!showSharePanel)
	}

	const hideShowIfrmae = () => {
		setShowIframe(!showIframe)
	}

	const hideShowIframe = () => {
		setShowIframe(!showIframe)
	}

	const musicPlayerRender = showMediaPlayer ? (
		<MusicPlayer
			showMediaTitle={showMediaTitle}
			mediaVolume={mediaVolume}
		/>
	) : (
		<React.Fragment />
	)
	return (
		<>
			{showIframe && (
				<IframeModal
					modalContent={modalContent}
					onModalHidden={() => hideShowIframe()}
					primaryColor={'#000000'}
					secondaryColor={'#000000'}
				/>
			)}
			<div id='bottomBarLeft'>
				<BottomStoreSelector />
				{musicPlayerRender}
				{showScreenshot && <Screenshot />}
				{showSharePanel && (
					<SharePanel
						showSharePanel={showSharePanel}
						setShowSharePanel={setShowSharePanel}
						hideUserPanel={hideUserPanel}
						showScreenshot={showScreenshot}
						setShowScreenshot={setShowScreenshot}
						isMobile={isMobile}
						sharePanelData={sharePanelData}
					/>
				)}
				<UserPanel visible={userPanel && userCount} userCount={count} />
				<div id='social-button-wrapper'>
					{sharePanelData && sharePanelData.enable && (
						<SocialButton
							onClick={toggleSharePanel}
							isMobile={isMobile}
							active={showSharePanel}
							iconUrl={shareIconUrl}
							iconText='SHARE'
						/>
					)}
				</div>
				{![popupStoreId, exhibitStoreId].includes(storeId) && (
					<SignUpButton text={'SIGN UP'} onClick={hideShowIfrmae} />
				)}
			</div>
		</>
	)
}

export default BottomBarLeft
